import React, { Component } from 'react'
import ReactTable from 'react-table'
import Table from '../Table'
import 'react-table/react-table.css'
import { withStore } from '../store'
import { Service } from '../ApiService'
import Loader from '../Loader'
import DatePicker from '../DatePicker'
import SaveToExcelSVG from '../../svg/SaveToExcelSVG'
import { getFirstDayOfMonth, getLastDayOfMonth } from '../dateFunctions'

class PaymentReport extends Component {

    constructor(props) {
        super(props);
        var date = new Date();
        var date2 = new Date(date -  24 * 3600 * 1000);
        this.state = {
            data: [],
            loading: false,
            range: {
                start: date2,
                end: date
            }
        }
        this.updateData = this.updateData.bind(this);
        //this.dateStartDropDownRef = null;
        //this.dateEndDropDownRef = null;
        this.donwloadExcel = this.downloadExcel.bind(this);
    }

    updateData() {
        this.setState({ loading: true });
        Service.getPaymentReport(this.state.range).then(data => this.setState({ loading: false, data: data }));
    }

    componentDidMount() {
        let today = new Date();
        let lastYearToday = new Date(today.getFullYear()-1, today.getMonth());
        let range = {
            start: getFirstDayOfMonth(lastYearToday),
            end: getLastDayOfMonth(today)
        }
        this.setState({ range: range }, this.updateData);
        //this.updateData();
    }
    downloadExcel = () => {
        this.setState({ loading: true });
        Service.downloadWithPost('/api/Reports/PaymentReportToExcel', this.state.range).then(blob => {
            Service.throwBlob(blob, 'PaymentReport.xlsx');
            this.setState({ loading: false });
        });
    }
    render() {
        let total = 0;
        this.state.data.forEach(a => { total += a.attendance; })
        const columns = [
            { title: "Customer", accesor: 'customer', filterable: true },
            { title: "Event", accesor: 'event', filterable: true },
            { title: "Order Date", accesor: 'orderDate', filterable: true },
            { title: "Order#", accesor: 'orderNumber', filterable: true },
            { title: "Amount", accesor: 'amount', filterable: true },
        ]
        return (
        <div>
            <div className='filter-nav-wrapper'>
                <div className='filter-wrapper'>
                    <div className='flex-nowrap align-center'>
                        <span className='mr-05 uppercase-text'>From:</span>
                        <DatePicker
                            value={this.state.range.start}
                            maxDate={this.state.range.end}
                            noClearButton={true}
                            //ref={el => this.dateStartDropDownRef = el}
                            onSelect={value => {
                                var range = this.state.range;
                                range.start = value;
                                this.setState({ range: range });
                                setTimeout(this.updateData, 50);
                            }}
                        />
                    </div>
                    <div className='flex-nowrap align-center'>
                        <span className='mr-05 uppercase-text'>To:</span>
                        <DatePicker
                            value={this.state.range.end}
                            minDate={this.state.range.start}
                            noClearButton={true}
                            //ref={el => this.dateEndDropDownRef = el}
                            onSelect={value => {
                                var range = this.state.range;
                                range.end = value;
                                this.setState({ range: range });
                                setTimeout(this.updateData, 50);
                            }}
                        />
                    </div>
                </div>
                <button className='round-button medium-round-button outline-on-hover' onClick={this.downloadExcel} >
                    <SaveToExcelSVG />
                    <span>Excel</span>
                </button>
            </div>
            {this.state.loading && <Loader />}
            <h3 className='mr-05 ml-05 mt-2 mb-2 uppercase-text'><strong>Payment Report</strong></h3>
            {/*    {this.state.loading && <Loader />}
                <h1>Veteran's Attendance by Date Range</h1>
                <span>Date From:</span>
                <div style={{ display: "inline-block", width:"300px" }}>
                    <DatePicker
                        value={this.state.range.start}
                        maxDate={this.state.range.end}
                        ref={el => this.dateStartDropDownRef = el}
                        onSelect={value => {
                            var range = this.state.range;
                            range.start = value;
                            this.setState({ range: range });
                            setTimeout(this.updateData, 50);
                        }}
                    />
                </div>
                <span>Date To:</span>
                <div style={{ display: "inline-block", width: "300px" }}>
                <DatePicker
                    value={this.state.range.end}
                    minDate={this.state.range.start}
                    ref={el => this.dateEndDropDownRef = el}
                    onSelect={value => {
                        var range = this.state.range;
                        range.end = value;
                        this.setState({ range: range });
                        setTimeout(this.updateData, 50);
                    }}
                    />
                </div><button onClick={this.donwloadExcel}>Excel</button> */}
                <Table data={this.state.data} columns={columns} showRowDetails={true} addHeadersForNarrowScreen={true} headerClassName='background-tableheaderWithDetails' className='break-at-700'
                    detailProperty='lines'
                    detailRenderer={(row) => {
                        return <div style={{ display: "block", marginLeft: '10px', fontSize: 'small'}}>{row.lines.map(line => {
                            return <div>{Object.keys(line).map(prop => <span style={{ marginRight: '10px', fontStyle: 'italic' }}>{line[prop]}</span>)}</div>
                        })}</div>
                    }}
                />
        </div>);
    }

}
export default withStore(PaymentReport);


// WEBPACK FOOTER //
// ./src/components/reports/PaymentReport.jsx